<script setup lang="ts">
defineProps<{
  code: string
}>()
</script>

<template>
  <Icon v-if="code === 'en'" name="circle-flags:us" />
  <Icon v-else-if="code === 'es'" name="circle-flags:es-variant" />
  <Icon v-else-if="code === 'be'" name="circle-flags:by" />
  <Icon v-else-if="code === 'uk'" name="circle-flags:ua" />
  <Icon v-else-if="code === 'ar'" name="circle-flags:sa" />
  <Icon v-else :name="`circle-flags:${code}`" />
</template>
